document.addEventListener('click', event => {
  const button = event.target.closest('[data-artwork]');
  if (!button) return;
  const gallery = button.closest('.af-artgallery');
  gallery.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== button.dataset.artwork; });
  gallery.querySelectorAll('[data-artwork]').forEach(thumb => { thumb.setAttribute('aria-pressed', String(thumb === button)); });
});
document.addEventListener('change', event => {
  const input = event.target;
  if (!input.matches('input[type="file"][data-max-bytes]')) return;
  const file = input.files && input.files[0];
  let message = '';
  if (file && !['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) message = input.dataset.typeError;
  else if (file && file.size > Number(input.dataset.maxBytes)) message = input.dataset.sizeError;
  input.setCustomValidity(message);
  if (message) input.reportValidity();
});
document.addEventListener('click', event => {
  const open = event.target.closest('[data-open-upload]');
  if (open) {
    const dialog = document.querySelector('#af-product-form dialog');
    if (dialog && !dialog.open) dialog.showModal();
  }
  const close = event.target.closest('[data-close-upload]');
  if (close) close.closest('dialog').close();
});
document.addEventListener('change', event => {
  const form = event.target.closest('#af-product-form');
  if (!form) return;
  const submit = form.querySelector('[data-order-enabled]');
  if (submit) submit.disabled = submit.dataset.orderEnabled !== 'true' || !form.checkValidity();
});
